var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "gh-card gh-card--text",
      class: { "gh-card--collapsed": _vm.collapsed },
    },
    [
      _vm._t("context-head"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gh-card-text__header" },
        [
          _c("div", { staticClass: "gh-card-text__header-left" }, [
            _c(
              "button",
              {
                staticClass: "gh-card__chevron",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggle-collapse")
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.collapsed
                    ? "fa fa-chevron-up"
                    : "fa fa-chevron-down",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "gh-card-text__title" }, [
              _vm._v(_vm._s(_vm.cardTitle)),
            ]),
          ]),
          _vm._v(" "),
          _c("GenerationHistoryCardActions", {
            attrs: {
              "is-favorite": _vm.card.is_favorite,
              "is-copied": _vm.isCopied,
            },
            on: {
              copy: function ($event) {
                return _vm.$emit("copy")
              },
              download: function ($event) {
                return _vm.$emit("download")
              },
              favorite: function ($event) {
                return _vm.$emit("favorite")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "GenerationHistoryCardSlide",
        { attrs: { expanded: !_vm.collapsed } },
        [
          _c("div", { staticClass: "gh-card-text__body" }, [
            _c("div", { staticClass: "gh-card-text__output" }, [
              _c(
                "div",
                {
                  staticClass: "gh-card__text",
                  class: { "gh-dnd-source": _vm.canDrag && _vm.outputBody },
                  attrs: { draggable: _vm.canDrag && !!_vm.outputBody },
                  on: {
                    dragstart: _vm.onNamingTextDragStart,
                    dragend: _vm.onDragEnd,
                  },
                },
                [
                  _c("vue-markdown", {
                    staticClass: "markdown-custom",
                    attrs: { source: _vm.outputBody, "task-lists": false },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gh-card-text__meta" },
              [
                _c("GenerationHistoryMetaRows", {
                  attrs: {
                    fields: _vm.metaFields,
                    variant: "detail",
                    "row-key-prefix": `naming-${_vm.card.item_id}`,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }